import React from 'react';
import { Card, ProgressBar } from 'react-bootstrap';

/**
 * Progress Card Component
 * Displays overall course progress
 */
export function ProgressCard({ progress, course }) {
  if (!progress || !course) {
    return null;
  }

  const completionPercentage = (progress.completedSections.length / course.sections.length) * 100;

  return (
    <Card className="progress-card mb-4">
      <Card.Body>
        <h5 className="card-title">Your Progress</h5>
        
        <div className="mb-3">
          <div className="d-flex justify-content-between mb-2">
            <span>Overall Score</span>
            <strong>{Math.round(progress.overallScore)}%</strong>
          </div>
          <ProgressBar 
            now={progress.overallScore} 
            variant={getScoreVariant(progress.overallScore)}
            label={`${Math.round(progress.overallScore)}%`}
          />
        </div>

        <div className="mb-3">
          <div className="d-flex justify-content-between mb-2">
            <span>Sections Completed</span>
            <strong>{progress.completedSections.length} / {course.sections.length}</strong>
          </div>
          <ProgressBar 
            now={completionPercentage} 
            variant="success"
          />
        </div>

        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-value">{progress.unlockedSections.length}</div>
            <div className="stat-label">Sections Unlocked</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {Object.keys(progress.questionProgress).filter(q => {
                const qp = progress.questionProgress[q];
                return (qp.timesShown ?? qp.attempts ?? 0) > 0;
              }).length}
            </div>
            <div className="stat-label">Questions Attempted</div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

function getScoreVariant(score) {
  if (score >= 85) return 'success';
  if (score >= 70) return 'info';
  if (score >= 60) return 'warning';
  return 'danger';
}
